import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyBXDDGAIn7WJJlR4lku5oT5XZHhWGw0gj0",
    authDomain: "tiktok-clone-ddc29.firebaseapp.com",
    projectId: "tiktok-clone-ddc29",
    storageBucket: "tiktok-clone-ddc29.appspot.com",
    messagingSenderId: "408611980039",
    appId: "1:408611980039:web:22fa12db034c3c0dc53ba2",
    measurementId: "G-L0HDG2GLJQ"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;